import { Skeleton } from '@/components/ui/skeleton';
import { formatNumber } from '@/utils/number';

interface FooterAmountProps {
  amount: number | undefined;
}

export function FooterAmount({ amount }: FooterAmountProps) {
  if (amount === undefined) return <Skeleton className="h-4 w-14" />;
  return <span className="tabular-nums">{formatNumber(amount)}</span>;
}
